import React from "react";
import _ from "lodash";
import moment from "moment";

const Table = ({ data, parameters, history, title }) => {
  if (!history) history = 7;
  //   Data is reversed because it gets passed in ascending
  return (
    <table className="table table-sm table-hover text-right text-nowrap">
      <caption style={{ captionSide: "top", fontWeight: 700, padding: 0 }}>
        {title}
      </caption>
      <thead>
        <tr>
          <th className="text-left" style={{ width: "20%" }}>
            Name
          </th>
          {!_.isEmpty(data) &&
            [...data[parameters[0]].data]
              .reverse()
              .map((d) => (
                <th key={d.FTR_DATE}>{moment(d.FTR_DATE).format("ddd Do")}</th>
              ))}
        </tr>
      </thead>
      <tbody>
        {!_.isEmpty(data) &&
          parameters.map((code) => (
            <tr key={code}>
              <td className="text-left">{data[code].Name}</td>
              {[...Array(history)].map((a, i) => (
                <td key={i}>
                  {data[code].data[history - i - 1]
                    ? data[code].data[history - i - 1].PARAM_VALUE.toFixed(
                        data[code].Precision
                      )
                    : Number(0).toFixed(data[code].Precision)}
                </td>
              ))}
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default Table;
